import { ICustomersByResellerParams } from './useInfiniteCustomersByResellerQuery';

export const customerKeys = {
  customer_overlay_status: (customerId: string) =>
    ['CUSTOMER_OVERLAY_STATUS', customerId] as const,
  customers_by_reseller: (params: ICustomersByResellerParams) =>
    ['CUSTOMERS_BY_RESELLER', params] as const,
};
